/**
 * Extract the base host of a given TLD (remove all sub-domains).
 * Ex:
 * - getBaseHost("essec.dev.jobteaser.net") == ".jobteaser.net"
 * - getBaseHost("foo.bar.dev.jobteaser.net") == ".jobteaser.net"
 * - getBaseHost("localhost:4001") == "localhost"
 *
 * This helper is especially useful when you need to determine the base host of
 * the current request, in order to write a cookie on that domain and all its
 * sub-domains (like all ".dev.jobteaser.net" subdomains).
 *
 * @param fullHost - The full host from which the base host will be extracted (can contain port)
 * @returns - The base host, stripped from subdomains & port (may start by `.`)
 */
export function getBaseHost(fullHost: string): string {
  const baseHostParts = fullHost.split(":")[0].split(".").slice(-2)

  return baseHostParts.length > 1 ? `.${baseHostParts.join(".")}` : baseHostParts[0]
}
